export default __webpack_public_path__ + "static/media/total_control.0bf5a9b2.svg";